import { Button, Stack } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { PLACEMENT_TYPES } from '../utils/placementTypes';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { patchPlacementTracker } from '../../../../redux/features/generalSlice';
import { useSelector } from 'react-redux';

export default function ChangePlacementStatus({ row, setModalState, setRefresh }) {
  const [status, setStatus] = useState({ id: '', value: row?.placement_type ?? '' });
  const submitLoading = useSelector((state) => state.general.submitLoading);
  const dispatch = useDispatch();
  const apiHelper = useHandleApiResponse();

  const handleSubmit = () => {
    const data = {
      placement_tracker_id: row?.placement_tracker_id,
      placement_type: status.value,
    };
    dispatch(patchPlacementTracker(data)).then((res) => {
      apiHelper(res, {
        onSuccess: () => {
          setModalState(false);
          setRefresh((prev) => !prev);
        },
      });
    });
  };

  return (
    <Stack gap={2}>
      <GlobalSelectFieldWithoutFormikNew
        data={PLACEMENT_TYPES}
        keys={{
          itemId: 'id',
          itemValue: 'label',
        }}
        label={'Status'}
        selectedDetails={PLACEMENT_TYPES.find((e) => e.label === status.value)}
        setChange={setStatus}
      />
      <Button
        variant="contained"
        color="primary"
        sx={{
          alignSelf: 'flex-end',
        }}
        onClick={handleSubmit}
        disabled={!Boolean(status.value) || submitLoading}
      >
        {submitLoading ? 'Submitting...' : 'Submit'}
      </Button>
    </Stack>
  );
}
